var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire"}},[_c('v-toolbar',{staticClass:"navbar",attrs:{"height":"100px","flat":""}},[_c('Header')],1),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }